import {Component} from '@angular/core';
import {GenericConfig} from '@signature-it/ngx-generic/config';
import {FeaturesService} from '@signature-it/ngx-generic/services';
import {take} from 'rxjs/operators';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {GroupApiService, SharedDataService} from '@signature-it/ngx-catalogue/services';

declare var _: any;

@Component({
    selector: 'sort',
    templateUrl: './sort.component.html',
    styleUrls: ['./sort.component.scss'],
    standalone: false
})

export class SortComponent {

    title = GenericConfig.catalogueSort.title;
    options = [];
    selectedOption = GenericConfig.solr_parameters ? GenericConfig.solr_parameters.sort : '';

    constructor(private featuresSvc: FeaturesService,
                private sharedData: SharedDataService,
                private groupSvc: GroupApiService,
                private router: Router,
                private route: ActivatedRoute) {
        this.getSortOptions();
    }

    getSortOptions() {
        const groupId = this.sharedData.groupId;
        if (groupId) {
            this.featuresSvc.getCatalogueSortOptions(groupId).subscribe(
                (res: []) => {
                    if (res) {
                        this.route.queryParams.subscribe((queryParams) => {
                            if (queryParams.sort) {
                                this.selectedOption = queryParams.sort;
                            }
                            this.options = res;
                        });
                    }
                }
            );
        }
    }

    onSortChange() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {sort: this.selectedOption},
            queryParamsHandling: 'merge'
        });
    }
}
